import * as React from 'react';
import { SVGProps } from 'react';

export function ErrorIcon(props: SVGProps<SVGSVGElement>) {
  const { fill, color = 'white' } = props;

  return (
    <svg
      style={{ width: 'inherit', height: 'inherit' }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.00004 1.33325C4.31814 1.33325 1.33337 4.31802 1.33337 7.99992C1.33337 11.6818 4.31814 14.6666 8.00004 14.6666C11.6819 14.6666 14.6667 11.6818 14.6667 7.99992C14.6667 4.31802 11.6819 1.33325 8.00004 1.33325Z" fill={color} />
      <path d="M5.1953 5.19526C5.45565 4.93491 5.87776 4.93491 6.13811 5.19526L8.00004 7.0572L9.86197 5.19526C10.1223 4.93491 10.5444 4.93491 10.8048 5.19526C11.0651 5.45561 11.0651 5.87772 10.8048 6.13807L8.94284 8L10.8048 9.86193C11.0651 10.1223 11.0651 10.5444 10.8048 10.8047C10.5444 11.0651 10.1223 11.0651 9.86197 10.8047L8.00004 8.9428L6.13811 10.8047C5.87776 11.0651 5.45565 11.0651 5.1953 10.8047C4.93495 10.5444 4.93495 10.1223 5.1953 9.86193L7.05724 8L5.1953 6.13807C4.93495 5.87772 4.93495 5.45561 5.1953 5.19526Z" fill={fill} />
    </svg>
  );
}
